module.exports = __webpack_public_path__ + "media/images/icons/medupp-brain-fdde9e182c61c8f06ec78430c76b04ba.svg";